
define('text!views/shared/browserwarning/browserwarning.html',[],function () { return '<p class=\'browsehappy\'>You are using an <strong>outdated</strong> browser. Please <a href=\'http://browsehappy.com/\'>upgrade your browser</a> to improve your experience.</p>';});

